module.exports = __webpack_public_path__ + "static/media/ios-chrome-search.4a7e993d.jpeg";